export const EMPTY_DATA = '-';